import React, { Fragment, useEffect } from 'react';
import AboutBg from '../../../svg_img/whoweare.svg'
import Aos from 'aos';
import "aos/dist/aos.css";

function About() {
    useEffect(() => {
        Aos.init({});
    })
  return (
      <Fragment>
        <div className="xl:max-w-[1350px] 2xl:max-w-[1490px] mt-[125px] mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 items-center" data-aos="fade-up" data-aos-delay="100">
            <div
                className="sm:hidden lg:inline-block lg:w-[950px] lg:h-[750px] justify-center bg-no-repeat ml-[-78px]"
                style={{ backgroundImage: `url(${AboutBg})` }}
            ></div>
            <div className="space-y-6 ml-[20px] lg:ml-0 xl:ml-[-16px] 2xl:ml-[50px] mt-[-80px]  lg:mt-0 mb-[100px] lg:mb-0">
                <h1 className="font-bold text-[#6F5DE0] text-4xl lg:text-5xl">Who we are</h1>
                <p className="w-[340px] lg:w-[680px] text-2xl">
                Unacceptable help students visualize different curriculum topics, which are challenging to learn or visualize while having much fun, making it easy for students to learn and gain practical knowledge of its working. It is also a platform where students can discuss different topics in the chat room.
                </p>
                {/* <button className="bg-[#6F5DE0] hover:bg-[#6F5DE0] text-white font-bold py-4 px-12 rounded">
                    START NOW
                </button> */}
            </div>
        </div>
      </Fragment>
  );
}

export default About;
